import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBw2uzXE3w5Hh96HoVHvMEwDNRvJdODI3Y",
  authDomain: "riddleme-2eb75.firebaseapp.com",
  projectId: "riddleme-2eb75",
  storageBucket: "riddleme-2eb75.firebasestorage.app",
  messagingSenderId: "30554334428",
  appId: "1:30554334428:web:1823ecdc961671e19cc019",
  measurementId: "G-7BHCLNYLRH",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
